import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';
class DataLakeAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'datalake';
	getDetailCveAsync(cve) {
		let request = {
			url: [this.getAPIUrl(), 'cves_detail', cve].join('/')
		};
		return httpClient.getAsync(request);
	}
	insertBatchDataCveByYear(payload) {
		let request = {
			url: [this.getAPIUrl(), 'insert_data_cve_by_year'].join('/'),
			data: payload
		};
		return httpClient.postAsync(request);
	}
	getDataStatistics() {
		let request = {
			url: [this.getAPIUrl(), 'statistics'].join('/')
		};
		return httpClient.getAsync(request);
	}
	getRedditPosts(payload) {
		let request = {
			url: [this.getAPIUrl(), 'reddit_posts'].join('/'),
			data: payload
		};
		return httpClient.postAsync(request);
	}
	getDetailRedditPost(id) {
		let request = {
			url: [this.getAPIUrl(), 'reddit_posts_detail', id].join('/')
		};
		return httpClient.getAsync(request);
	}
	getDataStatistics() {
		let request = {
			url: [this.getAPIUrl(), 'statistics'].join('/')
		};
		return httpClient.getAsync(request);
	}
	getSchedule() {
		let request = {
			url: [this.getAPIUrl(), 'get_schedule'].join('/')
		};
		return httpClient.getAsync(request);
	}
	updateSchedule(payload) {
		let request = {
			url: [this.getAPIUrl(), 'update_schedule'].join('/'),
			data: payload
		};
		return httpClient.postAsync(request);
	}
	getVendors(payload) {
		let request = {
			url: [this.getAPIUrl(), 'vendors'].join('/'),
			data: payload
		};
		return httpClient.postAsync(request);
	}
	getProducts(payload) {
		let request = {
			url: [this.getAPIUrl(), 'products'].join('/'),
			data: payload
		};
		return httpClient.postAsync(request);
	}
}

export default new DataLakeAPI();
